import React from 'react';

/* eslint-disable no-tabs */
export default function currentActiveStep(
	exclaimation = false,
	loading = false,
	hasWallet = false,
	submission_date = false,
	pending = false,
	approved = false
) {
	
	if (submission_date && pending) {
		return {
			active_step: 2,
			message: loading ? (
				'Checking your status ... '
			) : (
				<span>
					Identity Verification Submitted <br /> Wait for approval or resubmit if rejected
				</span>
			),
			link: `${exclaimation && !pending ? 'KYC-SUBMIT' : null}`
		};
	} else if (submission_date && approved) {
		return {
			active_step: 3,
			message: loading ? (
				'Checking your status ... '
			) : (
				<span>
					Identity Verification Approved <br /> Start a new loan or view your loans
				</span>
			),
			link: 'LOAN_LIST'
		};
	} else {
		return {
			active_step: 1,
			message: loading ? (
				'Checking your status ... '
			) : (!hasWallet && !submission_date) || (hasWallet && !submission_date) ? (
				<span>
					Account Created <br /> Please create your wallet then complete your identity verification
				</span>
			) : (
				<span>
					Account Created <br /> Please create your wallet then complete your identity verification
				</span>
			)

			// link: 'DWOLLA_PLAID'
		};
	}
}
